import {
  IconToggleHeartOff24,
  IconActionSearch24,
  IconActionPlusCircle24,
  IconActionNotification24,
  IconActionMessageLine24,
  IconFinanceMortgage24,
  IconActionInfo24,
  IconActionHide24,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { IconBusinessAnalytics24 } from './BusinessAnalytics24';
import { IconComplaints24 } from './Complaints24';
import { IconDeals24 } from './Deals24';
import { IconFlatValuation24 } from './FlatValuation24';
import { IconInspection24 } from './Inspection24';
import { IconMarketPulse24 } from './MarketPulse24';
import { IconMortgageCalculator24 } from './MortgageCalculator24';
import { IconMortgageForm24 } from './MortgageForm24';
import { IconMyDeals24 } from './MyDeals24';
import { IconReportProblem24 } from './ReportProblem24';
import { IconRequestAgentHelp24 } from './RequestAgentHelp24';
import { IconSaleRent24 } from './SaleRent24';
import { IconSavedSearches24 } from './SavedSearches24';

export const ICONS: Record<string, React.ReactElement> = {
  deals: <IconDeals24 color="icon-primary-default" />,
  complaints: <IconComplaints24 color="icon-primary-default" />,
  hiddenOffers: <IconActionHide24 color="icon-primary-default" />,
  requestAgentHelp: <IconRequestAgentHelp24 color="icon-primary-default" />,
  businessAnalytics: <IconBusinessAnalytics24 color="icon-primary-default" />,
  messages: <IconActionMessageLine24 color="icon-primary-default" />,
  favorites: <IconToggleHeartOff24 color="icon-primary-default" />,
  savedSearches: <IconSavedSearches24 color="icon-primary-default" />,
  flatValuation: <IconFlatValuation24 color="icon-primary-default" />,
  helpCenter: <IconActionInfo24 color="icon-primary-default" />,
  marketPulse: <IconMarketPulse24 color="icon-primary-default" />,
  mortgageCalculator: <IconMortgageCalculator24 color="icon-primary-default" />,
  mortgageForm: <IconMortgageForm24 color="icon-primary-default" />,
  placeOffer: <IconActionPlusCircle24 color="icon-primary-default" />,
  reportProblem: <IconReportProblem24 color="icon-primary-default" />,
  notifications: <IconActionNotification24 color="icon-primary-default" />,
  search: <IconActionSearch24 color="icon-primary-default" />,
  saleRent: <IconSaleRent24 color="icon-primary-default" />,
  e2eMortgage: <IconFinanceMortgage24 color="icon-primary-default" />,
  inspection: <IconInspection24 color="icon-primary-default" />,
  myDeals: <IconMyDeals24 color="icon-primary-default" />,
};
